export class Triggers {
  constructor () {
    this.events = {}
    this.onceEvents = {}
    this.emitDelays = {}
    this.on = this.on.bind(this)
    this.once = this.once.bind(this)
    this.off = this.off.bind(this)
    this.emitEvent = this.emitEvent.bind(this)
  }

  _addListener (eventName, listener) {
    if (!this.events[eventName]) {
      this.events[eventName] = new Set()
    }
    this.events[eventName].add(listener)
  }

  on (eventName, listener) {
    if (!eventName || !listener) return
    if (eventName instanceof Array) {
      for (const name of eventName) {
        this._addListener(name, listener)
      }
    } else {
      this._addListener(eventName, listener)
    }
  }

  off (eventName, listener) {
    if (!eventName || !listener || !this.events[eventName]) return
    this.events[eventName].delete(listener)
  }

  once (eventName, listener) {
    if (!eventName || !listener) return
    this.on(eventName, listener)
    if (!this.onceEvents[eventName]) {
      this.onceEvents[eventName] = new WeakSet()
    }
    this.onceEvents[eventName].add(listener)
  }

  emitEvent (eventName, args = []) {
    if (
      !eventName ||
      !this.events[eventName]
    ) return

    const onceListeners = this.onceEvents[eventName]

    // Delay for remove duplicate call with a short gap in between
    this.emitDelays[eventName] && clearTimeout(this.emitDelays[eventName])
    this.emitDelays[eventName] = setTimeout(() => {
      for (const listener of this.events[eventName]) {
        listener(...args)
        if (onceListeners && onceListeners.has(listener)) {
          this.off(eventName, listener)
          onceListeners.delete(listener)
        }
      }
    }, 99)
  }
}
